"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionService = exports.StorageType = exports.key_dettaglioPolizza = exports.key_filtroRicercaAnagrafica = exports.key_cliente = void 0;
const CryptoJS = __importStar(require("crypto-js"));
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const constants_1 = require("../common/constants");
/**
 * definizione delle costanti chiave per il localStorage
 */
exports.key_cliente = 'cliente';
exports.key_filtroRicercaAnagrafica = 'filtro';
exports.key_dettaglioPolizza = 'dettaglioPolizza';
/**
 * Questo servizio serve a criptare un oggetto javascript e inserirlo nel local storage
 */
var StorageType;
(function (StorageType) {
    StorageType["Local"] = "local";
    StorageType["Session"] = "session";
})(StorageType = exports.StorageType || (exports.StorageType = {}));
class EncryptionService {
    static encryptSingleData(data, algorithm, key) {
        let response = undefined;
        try {
            response = CryptoJS[algorithm].encrypt(data, key);
        }
        catch (e) {
            console.error("Errore durante l'encrypt del dato con algoritmo", algorithm, e);
        }
        return response;
    }
    static createDigest(data) {
        return CryptoJS.MD5(data);
    }
    static encrypt(key, data, target = StorageType.Session) {
        const encryptedData = CryptoJS.AES.encrypt(data, constants_1.Constants.vendor.var).toString();
        nodejs_library_1.Helpers.SessionHelper.setData(key, encryptedData);
    }
    static decrypt(key, target = StorageType.Session) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const val = yield nodejs_library_1.Helpers.SessionHelper.getData(key);
                if (val) {
                    const bytes = CryptoJS.AES.decrypt(val.toString(), constants_1.Constants.vendor.var);
                    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
                    return decryptedData;
                }
            }
            catch (error) {
                return null;
            }
            return null;
        });
    }
}
exports.EncryptionService = EncryptionService;
